import { API } from "aws-amplify";
import { getEntityField } from "~/graphql/queries";
import * as APITypes from "~/API";

export const EMPTY_ENTITY_FIELD: APITypes.EntityField = {
  id: "",
  entityType: "",
  entityID: "",
  type: APITypes.EntityFieldType.Image,
  value: "",
  name: "",
  __typename: "EntityField",
  createdAt: "",
  updatedAt: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const getEntityFieldDetails = async (id: string) => {
  try {
    const response = (await API.graphql({
      query: getEntityField,
      variables: {
        id: id,
      },
    })) as { data?: APITypes.GetEntityFieldQuery };

    return {
      success: true,
      data: response.data?.getEntityField || EMPTY_ENTITY_FIELD,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_ENTITY_FIELD,
      error,
    };
  }
};
